import  { Component } from "react";
import { Navigate } from "react-router-dom";
import { withRouter } from '../../common/with-router';
import {Card, Form, Button, Row, Col, Table, Dropdown, Modal} from "react-bootstrap";
import { FaSearch, FaFilter, FaFileExport } from "react-icons/fa";
import api from "../../services/api";
import { hasPerm, formataDataHoraExibicao } from '../../common/utils';
import Paginacao from '../../common/pagination';

class Logs extends Component {
    constructor(props) {
        super(props);
        this.onChangeBusca = this.onChangeBusca.bind(this);
        this.onClickPagina = this.onClickPagina.bind(this);
        this.buscaLog = this.buscaLog.bind(this);

        this.state = {
            listResults: [],
            error: "",
            busca: "",
            showModal: false,
            modalMessage: '',
            page_numb: 1,
            loading: true,
        };
    }

    componentDidMount(){
        this.consultaLogs(this.state.busca, this.state.page_numb)
    }

    consultaLogs(busca, page_numb=1){
        api.get(`/logs/?busca=${busca}&page=${page_numb}`)
        .then(response => {
            this.setState({
                loading: false,
                error: "",
                listResults: response.data
            });
        })
        .catch(error => {
            let erro_msg = 'Erro ao consultar logs, tente novamente.';

            if(error.response.status === 500){
                erro_msg = 'Servidor indisponível no momento';
            }
            else if(error.response.status === 403){
                erro_msg = 'Você não tem permissão acessar essa área';
            }

            this.setState({
                loading: false,
                error: erro_msg
            });
        });
    }

    openModal(message) {
        this.setState({ showModal: true, modalMessage: message });
    }

    closeModal() {
        this.setState({ showModal: false, modalMessage: '' });
    }

    renderRows = () => {
        if('results' in this.state.listResults && this.state.listResults.results.length > 0){
            return this.state.listResults.results.map((item) =>
            <tr key={item.action_time}>
                <td>{formataDataHoraExibicao(item.action_time)}</td>
                <td>{item.object_id}</td>
                <td>
                    {item.change_message ? (
                        <Button
                        variant="link"
                        size="sm"
                        className="p-0 m-0"
                        onClick={() => this.openModal(item.change_message)}
                        >
                        {item.object_repr}
                        </Button>
                    ) : (
                        item.object_repr
                    )}
                </td> 
                <td>{item.action_flag}</td> 
                <td>{item.user__first_name} {item.user__last_name}</td> 
                <td>{item.content_type__app_label}</td>                
            </tr>
            );
        }        

        return (
            <tr>
                <td colSpan={5}>Nenhum log cadastrado</td>
            </tr>
        );
    };

    onChangeBusca(e) {
        this.setState({
            busca: e.target.value
        });
    }

    onClickPagina(num_page) {
        this.setState({
            loading: true,
            page_numb: num_page
        });
        
        this.consultaLogs(this.state.busca, num_page)
    }

    buscaLog(e) {
        e.preventDefault();

        this.setState({
            loading: true,
        });
        
        this.consultaLogs(this.state.busca)
    }

    render() {
        if (!hasPerm('view_group')) {
            return <Navigate to='/sem-permissao' />
        }

        return (
            <div>
                <Row className="align-items-center">
                    <Col sm={6} lg={6}>
                        <h4 className="page-title">Logs</h4>
                    </Col>
                </Row>
                <Card className="cardDestaque">
                    <Card.Body>                    
                        <Row>
                            <Col sm={12} lg={12} className="mb-3 d-flex justify-content-end">
                                <Dropdown className="d-inline">
                                    <Dropdown.Toggle variant="outline-secondary" size="sm" className="mb-3">
                                        <FaFilter /> Filtrar
                                    </Dropdown.Toggle>

                                    <Dropdown.Menu>
                                        <div className="drop-filter">
                                            <Form method="get" onSubmit={this.buscaLog}>
                                                <Row>
                                                    <Col sm={12} xs={12}>
                                                        <Form.Group className="mb-3">
                                                            <Form.Label>Nome</Form.Label>                                  
                                                            <Form.Control
                                                                type="text"
                                                                name="busca"
                                                                value={this.state.busca}
                                                                onChange={this.onChangeBusca}
                                                                placeholder="Nome do log"
                                                                aria-label="Nome do log"
                                                                aria-describedby="basic-addon2"
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                </Row>

                                                <Button type="submit" variant="outline-secondary" size="sm">
                                                    <FaSearch /> Filtrar
                                                </Button>
                                            </Form>
                                        </div>
                                    </Dropdown.Menu>
                                </Dropdown>

                                <Button variant="outline-secondary" className="ms-2 mb-3" size="sm">
                                    <FaFileExport /> Exportar
                                </Button>
                            </Col>
                        </Row>    

                        <Table responsive className="custom-table">
                            <thead>
                                <tr>
                                    <th>Data</th>
                                    <th>Id do objeto</th>
                                    <th>Repr. do objeto</th>
                                    <th>Ação</th>
                                    <th>Usuário</th>
                                    <th>Área</th>
                                </tr>
                            </thead>
                            <tbody>
                                {this.state.loading ? (
                                <tr>
                                    <td colSpan={7}>Carregando...</td>
                                </tr>
                                ) : (
                                    this.state.error ? (
                                        <tr>
                                            <td colSpan={7}>{this.state.error}</td>
                                        </tr>
                                    ) : this.renderRows()
                                )}                                                       
                            </tbody>
                        </Table>       
                        { 
                            'results' in this.state.listResults && this.state.listResults.results.length > 0 && 
                            <Paginacao dados={this.state.listResults} loading={this.state.loading} page_numb={this.state.page_numb} _onClickPagina={this.onClickPagina} />
                        }                    
                    </Card.Body>                
                </Card>

                <Modal
                    show={this.state.showModal}
                    onHide={() => this.closeModal()}
                    centered
                >
                    <Modal.Header closeButton>
                        <Modal.Title>Detalhes do Log</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {this.state.modalMessage || 'Nenhuma descrição adicional.'}
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={() => this.closeModal()}>
                        Fechar
                        </Button>
                    </Modal.Footer>
                </Modal>
            </div>
        );
    }
}

export default withRouter(Logs);